/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AsteriskIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4UlEQVR4nOVUPWsUURQdoxgNimARhAj+A/uAsIWi42buxwvcuXeSYEpBLK3SrH/BIk3AwkIS0R8hKiSgKAFRC0lhJbYJaTZGeUOS+dg37GbdJnjhNvPOO+fdM+e9KPoviii7j2xdZPtz0N2EsgcjE0DW5RJ53kC6MjKBhPRRQGBpZAKI5noE2LJjE7UWF8+FvgPY9bpAwtl0CBvH8XiQnCi9A2R7SPYuYb1bXhORC8i2XxZoi1ypTpneQtLXngOcxb2nZH1ZPaVuIqb3ROR0TsD6s/DfdqMoOlUQ23pt76sKuYicB7Ltug0H4M/o0nlg3Tj6RvoVWGeB9WPDnp0kSSZK9mQQBtrQDaxU2OMsrnv8j71PlLUrNs3MyJSfxOcbSV8A2Zfa7W3qbo7N9+iS53Bu/mowSaHIoVPJ09Vz0WzPrzXGcpDyUyHbVrPP9qM9O3dtKHLnFiZ9WiqkZL/qgsD2zWOPRS4il4D1QyAZD4FtIRDLTRG5PBC5zy+wvQlYsiUiZzudzhiwfgqIbyDixb4CwPY86LlLrcBo0vBP1voLkK0GTvf+8Gk4LCR9O5RAq9U6A6SPgfT30ctJerPHSs5ulC8WkD7xFvYVKAj0NpB9B7ZnzdPqU4/xL/HAxCeu/gLxzLwaOhkRmAAAAABJRU5ErkJggg==)
 */
export const AsteriskIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19.94 7.03c.58-.28 1.27.01 1.46.62l1 3.1c.2.6-.19 1.25-.81 1.36l-6.73 1.2 4.71 4.98c.44.46.37 1.2-.14 1.57l-2.62 1.92c-.52.38-1.25.21-1.55-.35l-3.22-6.06-3.29 6.07c-.3.56-1.03.72-1.54.35l-2.63-1.93a1.05 1.05 0 0 1-.14-1.57l4.7-4.98-6.72-1.2c-.62-.11-1-.75-.81-1.36l1-3.1c.2-.61.88-.9 1.45-.63l6.24 3.01-.93-6.84C9.28 2.56 9.77 2 10.41 2h3.2c.63 0 1.12.56 1.04 1.18l-.88 6.85 6.17-3Z"
        className={colorClass}
      />
    </svg>
  );
};
